import React, { useEffect, useState } from "react";

function diff(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  return {
    live: ms === 0,
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms % 86400000) / 3600000),
    m: Math.floor((ms % 3600000) / 60000),
    s: Math.floor((ms % 60000) / 1000),
  };
}

export default function Countdown({ t }) {
  const target = t.premiere_date;
  const [c, setC] = useState(() => diff(target));

  useEffect(() => {
    if (!target || Number.isNaN(new Date(target).getTime())) return;
    const id = setInterval(() => setC(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target || Number.isNaN(new Date(target).getTime())) return null;

  const pad = (n) => String(n).padStart(2, "0");
  const cells = [
    [pad(c.d), t.countdown_days],
    [pad(c.h), t.countdown_hours],
    [pad(c.m), t.countdown_min],
    [pad(c.s), t.countdown_sec],
  ];

  return (
    <div data-testid="reality-countdown" className="inline-flex flex-col gap-3 border border-[#F1EDE6]/15 bg-[#0B0B0C]/60 backdrop-blur px-6 py-5">
      <div className="flex items-center gap-3 mono text-[9px] uppercase tracking-[0.32em] text-[color:var(--alta-red-soft)]">
        <span className="rec-dot !w-2 !h-2" aria-hidden="true" />
        {t.premiere_label} · {t.premiere_date_text}
      </div>
      {c.live ? (
        <div className="condensed text-[48px] md:text-[64px] text-[#F1EDE6] flicker" data-testid="reality-countdown-live">{t.countdown_live}</div>
      ) : (
        <div className="flex items-end gap-5 md:gap-7">
          {cells.map(([v, l], i) => (
            <div key={l} className="flex items-end gap-5 md:gap-7">
              <div className="text-center">
                <div className="condensed text-[48px] md:text-[64px] leading-none text-[#F1EDE6] tabular-nums">{v}</div>
                <div className="mt-1 mono text-[9px] uppercase tracking-[0.26em] text-[#F1EDE6]/50">{l}</div>
              </div>
              {i < cells.length - 1 && <span className="condensed text-[40px] md:text-[56px] leading-none text-[#F1EDE6]/30 pb-5">:</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
